/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span[_ngcontent-%COMP%]{display:inline-block;font-family:PoppinsThin,Arial,Verdana,Helvetica,sans-serif;font-weight:lighter;font-size:2.5rem;margin:0 1px;font-weight:600;text-align:center}span.countdown-timer-digit[_ngcontent-%COMP%]{padding:0 4px}.theme-light[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#444}.theme-dark[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff}.small-timer[_ngcontent-%COMP%]{line-height:.5}.small-timer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:1.5rem;font-family:PoppinsRegular,Arial,Verdana,Helvetica,sans-serif}"];
export { styles as styles };
//# sourceMappingURL=live-class-state-view-timer.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/live-class-state-view-timer/live-class-state-view-timer.component.scss.shim.ngstyle.js
// module id = 1521
// module chunks = 27 28 29